const colors = {
  lightContainerBackground: "#ffffff",
  darkContainerBackground: "#232f3e",
  headerSelectedBg: "orange",
  headerSelectedText: "black",
  headerText: "#f2f3f3",
  inverseHeaderText: "#232f3e",
  headerBorder: "orange",
  linkTextColor: "#0a4a74",
};

export default colors;
